import {ChangeDetectorRef, Component, EventEmitter, OnInit, Output} from '@angular/core';
import {ReactiveFormsModule, UntypedFormGroup} from '@angular/forms';
import {FaqCategory} from '../../../../model/FaqCategory';
import {FaqCategoryService} from '../../../../services/faq-category.service';
import {ProfileService} from '../../../../services/profile.service';

import {StepIndicatorComponent} from "../../../../components/user/step-indicator/step-indicator.component";
import {UserCoordsFormComponent} from "../user-coords-form/user-coords-form.component";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {CancelButtonComponent} from "../../../../components/common/cancel-button/cancel-button.component";
import {NgbTooltip} from "@ng-bootstrap/ng-bootstrap";
import {RouterLink} from "@angular/router";
import {UserProfileFormComponent} from "../user-profile-form/user-profile-form.component";
import {UserProductsListFormComponent} from "../user-products-list-form/user-products-list-form.component";
import {UserInfosFormComponent} from "../user-infos-form/user-infos-form.component";

@Component({
    selector: 'app-user-form',
    imports: [
    ReactiveFormsModule,
    StepIndicatorComponent,
    UserCoordsFormComponent,
    FaIconComponent,
    CancelButtonComponent,
    NgbTooltip,
    RouterLink,
    UserProfileFormComponent,
    UserProductsListFormComponent,
    UserInfosFormComponent
],
    templateUrl: './user-form.component.html',
    styleUrls: ['./user-form.component.css']
})
export class UserFormComponent implements OnInit {
  @Output() newUser = new EventEmitter<any>();

  // Current page of the form
  currentPage = 1;

  indicator = [
    'Coordonnées de l\'utilisateur',
    'Profils',
    'Logiciels',
    'Informations complémentaires',
  ];

  pageFormName = {
    1: 'coords',
    2: 'profile',
    3: 'products',
    4: 'infos'
  };

  form: UntypedFormGroup;
  products: FaqCategory[] = [];

  constructor(private faqCategoryService: FaqCategoryService,
              private profileService: ProfileService,
              private cd: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    this.form = new UntypedFormGroup({});

    this.faqCategoryService.getObjects().subscribe(cats => {
      this.profileService.getProfile().subscribe(profile => {
        profile.me.contracts.forEach(c => {
          const cat = cats.find(c2 => {
            return c2.slug.toLowerCase() === c.product.tag.toLowerCase();
          });
          if (cat !== undefined) {
            this.products.push(cat);
          }
        });
      });
    });
  }

  submitform(event): void {
    if (this.form.get(this.pageFormName[this.currentPage]).valid) {
      if (this.currentPage < 4) {
        this.currentPage++;
      } else {
        this.newUser.emit(this.form.value);
      }
    }
    event.preventDefault();
    event.stopImmediatePropagation();
  }

}
